import ButtonAuditEvents from "./ButtonAuditEvents";

function layout() {
  const ctxView = {
    model: "staff.access.audit",
    selectable: false,
    form_action: [],
    table_action: [],
    activeSearch: false,
    pagination: false,
    domain: [],
    fields: {
      name: {
        type: "char",
        readOnly: true,
      },
      view_events: {
        type: "custom_component",
        Component: ButtonAuditEvents,
      },
      shift_code: {
        type: "char",
        readOnly: true,
      },
      enter_shift: {
        type: "datetime",
        readOnly: true,
      },
      exit_shift: {
        type: "datetime",
        readOnly: true,
      },
      enter_effective: {
        type: "datetime",
        readOnly: true,
      },
      exit_effective: {
        type: "datetime",
        readOnly: true,
      },
      enter_biometric: {
        type: "datetime",
        readOnly: true,
      },
      exit_biometric: {
        type: "datetime",
        readOnly: true,
      },
      ttt: {
        type: "numeric",
        readOnly: true,
        decimalPlaces: 2,
      },
      hedo: {
        type: "numeric",
        readOnly: true,
        decimalPlaces: 2,
      },
      heno: {
        type: "numeric",
        readOnly: true,
        decimalPlaces: 2,
      },
      hedf: {
        type: "numeric",
        readOnly: true,
        decimalPlaces: 2,
      },
      henf: {
        type: "numeric",
        readOnly: true,
        decimalPlaces: 2,
      },
      reco: {
        type: "numeric",
        readOnly: true,
        decimalPlaces: 2,
      },
      recf: {
        type: "numeric",
        readOnly: true,
        decimalPlaces: 2,
      },
    },
    form: [],
    list: [
      { name: "name" },
      { name: "shift_code" },
      { name: "enter_shift" },
      { name: "exit_shift" },
      { name: "enter_effective" },
      { name: "exit_effective" },
      { name: "enter_biometric" },
      { name: "exit_biometric" },
      { name: "ttt" },
      { name: "hedo" },
      { name: "heno" },
      { name: "hedf" },
      { name: "henf" },
      { name: "reco" },
      { name: "recf" },
      { name: "view_events" },
    ],
  };

  return ctxView;
}

export { layout };